import Rest from '@/services/Rest';

/**
 * @typedef {UpcomingInvoicesService}
 */
export default class UpcomingInvoicesService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/upcoming-invoices'

  /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  export(data, config = {}) {
    return this.post(`/export`, data, config);
  }

  exportDetails(data, config = {}) {
    return this.post(`/details/export`, data, config);
  }
}
